
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { Router } from '@angular/router';
import { LookupKey } from '../../../shared/constants/lookup-keys';
import { LovSelectionService } from '../../../core/services/lov-selection.service';
import { ApiService } from '../../../core/services/api.service';
import { ApiRoot, ApiEndPoints } from '../../../shared/constants/api-endpoints';
import { ApplicationRequest } from '../../../shared/models/application-request.model';
import { AccountModel } from '../../../shared/models/loginuser.model';
import { OptionTranslateService } from '../../../shared/services/option-translate.service';
import { SharedService } from '../../../shared/services/shared.service';
import { Utils } from '../../../Utils/utils';
import { ApplicationsComponent } from "../applications/applications.component";
import { ServiceName } from '../../../shared/constants/services.enum';

@Component({
  selector: 'app-carnets',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, ApplicationsComponent],
  templateUrl: './carnets.component.html',
  styleUrl: './carnets.component.scss'
})
export class CarnetsComponent {
  requestPayload: ApplicationRequest = new ApplicationRequest();
  lookupKey = LookupKey;
  serviceName = ServiceName;
  
  loader: boolean = false;
  pageSize: any = 10;
  totalRecords: number = 0;
  pageIndex: number = 1;

  filterForm: FormGroup;
  applications: any = [];
  users: any = [];
  dateRanges: any = []

  accountCSN: string = "";
  accountId: string = ""
  lang: string = "en";
  // This method is used to initialize the class instance using router, fb, api, shared service, lov service, and option translate service
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private api: ApiService,
    private sharedService: SharedService,
    private lovService: LovSelectionService,
    private optionTranslateService: OptionTranslateService,
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.dateRanges = this.optionTranslateService.getOptions(
      'applicationDays',
      this.lang
    );
    this.filterForm = this.fb.group({
      service: [null],
      subService: [null],
      membership: [null],
      status: [null],
      user: [null],
      days: ["15"],
      search: ''
    });
    this.accountCSN =this.sharedService.getCsnAccountId('csn'); //7093
    this.accountId = this.sharedService.getCsnAccountId('id'); //7093
    let accounts = Utils.checkIsArray(this.sharedService.getUserProfile()?.Account) ?? [];
    accounts?.map((u: AccountModel) => {
      let obj = { Name: u['DC Name English'], Value: u.CSN }
      this.users.push(obj)
    })
    this.getApplications();
  }

  // This method is used to search
  search() {
    this.pageIndex = 1;
    this.getApplications();
  }
  // This method is used to remove search using event
  removeSearch(event: KeyboardEvent) {
    const value = this.filterForm.get('search')?.value?.trim() || '';
    if (value === '') {
      this.search();
    }
  }

  // This method is used to handle service change event using option
  onServiceChange(option: any) {
    this.lovService.setLovSelection(option.lovType, option.selectedLov);
    this.getApplications();
    if (!option.selectedLov) {
    }
  }

  // This method is used to apply filter using option
  applyFilter(option: any) {
    this.pageIndex = 1;
    this.getApplications();
  }
  // get list of SR/Application
  // This method is used to get applications
  getApplications() {
    this.loader = true;
    this.totalRecords = 0;
    this.applications = [];

    this.requestPayload.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();

    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["Account Id"] = this.accountCSN ? "" : this.accountId;
    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"].CSN = this.accountCSN;
    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Number"] = this.filterForm.get('search')?.value || '';
    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Type"] = this.filterForm.get('service')?.value || '';
    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Sub Type"] = this.filterForm.get('subService')?.value || '';
    this.requestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["Status"] = this.filterForm.get('status')?.value || '';

    this.requestPayload.body.PageSize = this.pageSize;
    this.requestPayload.body.StartRowNum = this.pageSize * (this.pageIndex - 1);
    this.requestPayload.body.NewQuery = this.pageIndex === 1;
    this.requestPayload.body.NoDays = this.filterForm.get('days')?.value || 15;

    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_SR_SUMMARY, this.requestPayload)
      .subscribe({
        // This method is used to handle the next callback using response
        next: (response: any) => {
          if (response?.SiebelMessage && response?.SiebelMessage['Service Request']) {
            this.loader = false;
            this.totalRecords = response.TotalRecords
            this.applications = Utils.checkIsArray(response?.SiebelMessage['Service Request']);
          } else {
            this.loader = false;
          }
        }, 
        // This method is used to handle the error callback
        error: () => {
          this.loader = false;
        }
      })
  }

  // This method is used to page change using page
  pageChange(page: any) {
    this.pageIndex = page;
    this.getApplications();
  }
  selectedRows: any = [];
  // This method is used to select row using rows
  selectRow(rows: any) {
    this.selectedRows = rows;
  }

  /* --- actions ---- */
  // This method is used to apply for service
  applyForService() {
    this.router.navigate([RoutesPath.SERVICES_LIST]);
  }
  // This method is used to export csv
  exportCSV() { }

  // This method is used to view app using sr
  viewApp(sr: any) {
    this.sharedService.gotoDetailPage(sr);
  }

  // This method is used to goto payment page using application
  gotoPaymentPage(application: any) {
    const csn = String(application?.['CSN']).trim();
    this.router.navigate(
      [`${RoutesPath.SERVICE}/${RoutesPath.PAYMENT}/${application["SR Number"]}`],
      { queryParams: csn ? { csn } : {} }
    );
  }
}
